import React from 'react';
import merge from 'classnames';

import { Props } from './types';

import styles from './ProductDescription.module.scss';

export const ProductDescription = ({
  title = 'PRODUCT INFORMATION',
  description,
  classes,
  children,
}: Props) => {
  return (
    <div className={styles.panel_wrapper}>
      {description && (
        <>
          <div className={styles.panel_title}>
            <span className={merge(styles.shingle_panel_title, classes?.title)}>{title}</span>
          </div>
          <div
            className={merge(
              styles.panel_subtitle,
              { [styles.product_information]: children },
              classes?.description,
            )}
          >
            {description}
          </div>
        </>
      )}
      {children}
    </div>
  );
};
